import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * List the signed-in user's saved library items.
 *
 * Identity comes from the bearer token alone — these endpoints require a
 * verified session and carry no `user_id` in the body, so there is nothing to
 * pass and nothing a caller could claim to be. (Contract v1.1: absent or
 * invalid token → 401 UNAUTHENTICATED.)
 *
 * @param {'location'|'vehicle'|'vehicle_type'} [itemType] - Narrow to one type;
 *   omit for everything.
 * @returns {Promise<{items: Array<Object>}>}
 */
async function saved_items_by_user(itemType) {
  const requestJson = itemType ? { item_type: itemType } : {};
  return generic_backend_request_post(requestJson, '/saved_items_by_user');
}

export default saved_items_by_user;
